import {
    AfterViewChecked,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AgprComponentStyleEnum } from '../../../Basic/enums/social-analysis-types.enum';
import { DropdownComponent } from '../Dropdown/dropdown.component';

/**
 * This class was copied and modified from PrimeNG's (5.2.7) dropdown
 * ### Accessibility Usage
 * Please follow the accessibility usage for dropdowns
 */
@Component({
    selector: 'agpr-icon-dropdown',
    templateUrl: './icon-dropdown.component.html',
    styleUrls: ['./icon-dropdown.component.scss'],
    animations: [
        trigger('panelState', [
            state('hidden', style({
                opacity: 0
            })),
            state('visible', style({
                opacity: 1
            })),
            transition('visible => hidden', animate('400ms ease-in')),
            transition('hidden => visible', animate('400ms ease-out'))
        ])
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: IconDropdownComponent,
            multi: true,
        }
    ],
    standalone: false
})
export class IconDropdownComponent extends DropdownComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy, ControlValueAccessor {
    readonly agprComponentStyle = AgprComponentStyleEnum;

    @Input() id: string = null;
    @Input() disabled: boolean = false;
    @Input() displayIcon: string;
    @Input() applyHighlight: boolean = false;

    @Output() change: EventEmitter<any> = new EventEmitter();

    @HostBinding('class.ui-inputwrapper-focus') focused: boolean = false;

    tooltipDisabled: boolean = false;

    constructor(
        public el: ElementRef,
        public renderer: Renderer2,
        public cd: ChangeDetectorRef,
        public zone: NgZone
    ) {
        super(
            el,
            renderer,
            cd,
            zone
        );
    }

    onInputFocus(event) {
        this.tooltipDisabled = true;
        this.focus.emit(event);
    }

    onInputBlur(event) {
        this.tooltipDisabled = false;
        this.onModelTouched();
        this.blur.emit(event);
    }
}
